export default [
  {
    id: 1,
    name: '0～19'
  },
  {
    id: 2,
    name: '20～49'
  },
  {
    id: 3,
    name: '50～99'
  },
  {
    id: 4,
    name: '100 以上'
  }
]
